import React from 'react';
import './Artist.css';
import artistImage from './images/artist-image.jpg'; // Import the artist image
import { useLanguage } from '../context/LanguageContext';

const Artist = () => {
  const { t } = useLanguage();

  return (
    <div className="artist" id="artist">
      <div className="artist-container">
        <h2 className="section-title">{t('artist.sectionTitle')}</h2>
        <div className="artist-profile">
          <div className="artist-image-container">
            <img src={artistImage} alt="Gabriel Conlitchenko — artist tatuaje la Kellink Tattoo Bacău" className="artist-image" />
          </div>
          <div className="artist-info">
            <h2 className="artist-name">{t('artist.name')}</h2>
            <h3 className="artist-title">{t('artist.title')}</h3>
            <p className="artist-bio">{t('artist.bio')}</p>
            <div className="artist-specialties">
              <h4>{t('artist.specialtiesTitle')}</h4>
              <div className="specialty-tags">
                {t('artist.specialties').map((specialty, index) => (
                  <span key={index} className="specialty-tag">{specialty}</span>
                ))}
              </div>
            </div>
            <div className="artist-experience">
              <h4>{t('artist.experienceTitle')}</h4>
              <p>{t('artist.experienceText')}</p>
            </div>
            <div className="artist-cta">
              <a href="#contact" className="artist-contact-btn">
                {t('artist.ctaButton')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Artist; 